export default __webpack_public_path__ + "static/media/ClanTracker.3a6daf27.PNG";